import { UsersAPI } from '../api/UsersAPI';

export const UserRepository = {
  validate: (contextData, usersData, challenge) => UsersAPI.validate(contextData, usersData, challenge),
  updateRetry: (contextData, usersData) => UsersAPI.updateRetry(contextData, usersData),
  prevalidate: (contextData, usersData) => UsersAPI.prevalidate(contextData, usersData)
};